import Vue from "vue";
import VueRouter from "vue-router";
import Bases from "../views/BasesView";
import Scor from "../views/ScorView";
import Scipts from "../views/ScrciptsView";
import Analytics from "../views/AnalyticsView";
import Calls from "../views/CallsView";
import Integrations from "../views/IntegrationsView";
import Help from "../views/HelpView";
import Cabinet from "../views/CabinetView";
import UserSettings from "../views/UserSettings";
import Users from "../views/admin/UsersAdminView";
import UsersPays from "../views/admin/PaymentsAdminView";
import Words from "../views/admin/WordsAdminView";
import BalckList from "../views/admin/BlackListAdminView";
import ExtraServices from "@/views/admin/ExtraServicesAdminView";
import TariffsMinutes from "@/views/admin/TariffsAdminView";
import Notifications from "@/views/admin/NotificationsView"
import MonitoringCall from "@/views/admin/MonitoringCall"
import Report from "@/views/ReportView";
import IncomingCalls from "@/views/IncomingCalls";
import StatisticsCRM from "@/views/admin/Statistics"
import CarouselNumbersAdmin from "@/views/admin/CarouselNumbersAdmin"
import CallAttemptsReport from "@/views/admin/CallAttemptsReport";
import YourNumbersView from "@/views/YourNumbersView";
import UserCarousels from "@/views/admin/UserCarousels";
import AdminVerificationCalls from "@/views/admin/AdminVerificationCalls.vue";
import TrunkCostsAdmin from "@/views/admin/TrunkCostsAdmin.vue";
// import NumberForUsers from "@/views/admin/NumberForUsers.vue";
import { store } from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/bases",
    name: "bases",
    component: Bases,
  },
  {
    path: "/score",
    name: "score",
    component: Scor,
  },
  {
  path: "/call_attempts_report",
  name: "call_attempts_report",
  component: CallAttemptsReport,
},
  {
    path: "/bases/:id",
    name: "base",
    component: Bases,
  },
  {
    path: "/scripts",
    name: "scripts",
    component: Scipts,
  },
  {
    path: "/analytics",
    name: "analytics",
    component: Analytics,
  },
  {
    path: "/report",
    name: "report",
    component: Report,
  },
  {
    path: "/your_numbers",
    name: "your_numbers",
    component: YourNumbersView,
  },
    {
    path: "/UserCarousels",
    name: "/UserCarousels",
    component: UserCarousels,
  },
  {
    path: "/calls",
    name: "calls",
    component: Calls,
  },
  {
    path: "/incoming_calls",
    name: "IncomingCalls",
    component: IncomingCalls,
  },
  {
    path: "/integrations",
    name: "integrations",
    component: Integrations,
  },
  {
    path: "/help",
    name: "help",
    component: Help,
  },
  {
    path: "/",
    name: "cabinet",
    component: Cabinet,
  },
  {
  path: "/registration",
  name: "registration",
  component: Cabinet,
  },
  {
    path: "/user_settings",
    name: "user_settings",
    component: UserSettings,
  },
  {
    path: "/users",
    name: "users",
    component: Users,
  },
  {
    path: "/users_payments",
    name: "users_pays",
    component: UsersPays,
  },
  {
    path: "/words",
    name: "words",
    component: Words,
  },
  {
    path: "/blacklist",
    name: "blacklist",
    component: BalckList,
  },
  {
    path: "/extra_services",
    name: "extra_services",
    component: ExtraServices,
  },
  {
    path: "/tariff_minutes",
    name: "tariff_minutes",
    component: TariffsMinutes,
  },
  {
    path: "/notifications",
    name: "notificationss",
    component: Notifications,
  },
  {
    path: "/monitoring_calls",
    name: "monitoring_calls",
    component: MonitoringCall,
  },
  {
    path: "/statistics",
    name: "/statistics",
    component: StatisticsCRM,
  },
  {
    path: "/CarouselNumbersAdmin",
    name: "/CarouselNumbersAdmin",
    component: CarouselNumbersAdmin,
  },
  {
    path: '/UserCallsSms',
    name: "UserCallsSms",
    component: AdminVerificationCalls,
  },
  {
    path: '/trunk-costs',
    name: 'TrunkCostsAdmin',
    component: TrunkCostsAdmin,
  },
  // {
  //   path: '/NumberForUsers',
  //   name: "NumberForUsers",
  //   component: NumberForUsers,
  // },
];

// Админские страницы: не-админа на них не пускаем. Раньше страница открывалась по прямой ссылке,
// показывала «вы не администратор», но уже слала запросы к админскому API (403 в логах бэкенда).
// Пока пользователь не загружен (login === 'wait'), пропускаем: решает App.vue после загрузки,
// иначе админа уводило бы с его страницы при каждом обновлении.
const ADMIN_VIEWS = new Set([
  Users, UsersPays, Words, BalckList, ExtraServices, TariffsMinutes, Notifications, MonitoringCall,
  StatisticsCRM, CarouselNumbersAdmin, CallAttemptsReport, UserCarousels, AdminVerificationCalls, TrunkCostsAdmin,
]);
routes.forEach((route) => {
  if (ADMIN_VIEWS.has(route.component)) route.meta = { ...(route.meta || {}), admin: true };
});

export const isAdminRoute = (route) => route.matched.some((r) => r.meta && r.meta.admin);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (isAdminRoute(to) && store.getters['user/isLogin'] === true && !store.getters['user/getUserFields'].is_admin) {
    return next({ path: '/' });
  }
  next();
});

export default router;
